module.exports = __webpack_public_path__ + "img/am.5314f8a6.png";